import { FunctionComponent, useContext } from 'react';

import { FlagsContext } from 'src/context';
import { useContextBar } from 'src/hooks/useContextBar';

interface Props {
  children: React.ReactNode;
  hasBanner: boolean;
}

export const ChannelsSideDrawer: FunctionComponent<Props> = ({
  children,
  hasBanner,
}) => {
  const { EnableContextBarOtherPage } = useContext(FlagsContext);
  const { open } = useContextBar();
  return (
    <aside
      className={[
        'flex',
        'flex-col',
        'basis-auto',
        'grow-0',
        'shrink-0',
        'overflow-hidden',
        'h-dvh',
        'z-20',
        'bg-white',
        'border-solid',
        'border-gray-200',
        'fixed',
        hasBanner ? `top-[40px]` : 'top-0',
        'right-0',
        `w-full`,
        'border-0',
        `min-[600px]:relative`,
        `min-[600px]:top-auto`,
        `min-[600px]:right-auto`,
        EnableContextBarOtherPage && open
          ? `min-[600px]:w-[clamp(280px,30%,360px)]`
          : `min-[600px]:w-[360px]`,
        `min-[600px]:border-r`,
      ].join(' ')}
    >
      {children}
    </aside>
  );
};
